
<template>
  <div class="authentication">
    <div class="container">
      <div class="row">
          <plan-page />


<!--          <div class="col-lg-4 cool-md-6 col-sm-12">-->
<!--            <div class="card">-->
<!--              <ul class="pricing body">-->
<!--                <li><big>베이직</big></li>-->
<!--                <li>유저 1</li>-->
<!--                <li>리드 1,000</li>-->
<!--                <li>15분 동기화</li>-->
<!--                <li>1,000 Works/ 5 Flow</li>-->
<!--                &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--                &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--                <li>-->
<!--                  <h3>120,000원</h3>-->
<!--                  <span>매달</span>-->
<!--                </li>-->
<!--                <li><button class="btn btn-primary btn-simple" @click="toLogin">신청</button></li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-lg-4 cool-md-6 col-sm-12">-->
<!--            <div class="card">-->
<!--              <ul class="pricing body active">-->
<!--                <li><big>스페셜</big></li>-->
<!--                <li>유저 1</li>-->
<!--                <li>리드 1,500</li>-->
<!--                <li>15분 동기화</li>-->
<!--                <li>1,500 Works/ 10 Flow</li>-->
<!--                &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--                &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--                <li>-->
<!--                  <h3>310,000원</h3>-->
<!--                  <span>매달</span>-->
<!--                </li>-->
<!--                <li><button class="btn btn-primary" @click="toLogin">신청</button></li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-lg-4 cool-md-6 col-sm-12">-->
<!--            <div class="card">-->
<!--              <ul class="pricing body">-->
<!--                <li><big>프리미엄</big></li>-->
<!--                <li>유저 1</li>-->
<!--                <li>리드 6,000</li>-->
<!--                <li>15분 동기화</li>-->
<!--                <li>6,000 Works/ 20 Flow</li>-->
<!--                &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--                &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--                <li>-->
<!--                  <h3>500,000</h3>-->
<!--                  <span>매달</span>-->
<!--                </li>-->
<!--                <li><button class="btn btn-primary btn-simple" @click="toLogin">신청</button></li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--        <div class="col-lg-4 cool-md-6 col-sm-12">-->
<!--          <div class="card">-->
<!--            <ul class="pricing body">-->
<!--              <li><big>캠페인 베이직</big></li>-->
<!--              <li>유저 1</li>-->
<!--              <li>리드 10,000</li>-->
<!--              <li>1분 동기화</li>-->
<!--              <li>10,000 Works/ 무제한 Flow</li>-->
<!--              &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--              &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--              <li>-->
<!--                <h3>1,980,000원</h3>-->
<!--                <span>매달</span>-->
<!--              </li>-->
<!--              <li><button class="btn btn-primary btn-simple" @click="toLogin">신청</button></li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-lg-4 cool-md-6 col-sm-12">-->
<!--          <div class="card">-->
<!--            <ul class="pricing body">-->
<!--              <li><big>캠페인 스페셜</big></li>-->
<!--              <li>유저 1</li>-->
<!--              <li>리드 25,000</li>-->
<!--              <li>1분 동기화</li>-->
<!--              <li>25,000 Works/ 무제한 Flow</li>-->
<!--              &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--              &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--              <li>-->
<!--                <h3>2,980,000원</h3>-->
<!--                <span>매달</span>-->
<!--              </li>-->
<!--              <li><button class="btn btn-primary btn-simple" @click="toLogin">신청</button></li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-lg-4 cool-md-6 col-sm-12">-->
<!--          <div class="card">-->
<!--            <ul class="pricing body">-->
<!--              <li><big>캠페인 프리미엄</big></li>-->
<!--              <li>유저 1</li>-->
<!--              <li>리드 50,000</li>-->
<!--              <li>1분 동기화</li>-->
<!--              <li>50,000 Works/ 무제한 Flow</li>-->
<!--              &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--              &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--              <li>-->
<!--                <h3>3,980,000원</h3>-->
<!--                <span>매달</span>-->
<!--              </li>-->
<!--              <li><button class="btn btn-primary btn-simple" @click="toLogin">신청</button></li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
        <div class="footer">
        <hr />
        <p class="copyright font-12">
          Copyright 2022 © All Rights Reserved. EASY WORK
        </p>
        <ul class="list-unstyled d-inline-flex mt-2">
          <!-- <li class="mr-3"><a href="#" target="_blank">연락처</a></li> -->
          <li class="mr-3">
            <a href="https://www.easywork.ai" target="_blank">소개</a>
          </li>
          <!--                <li class="mr-3"><a href="#" target="_blank">서비스</a></li>-->
          <!--                <li class="mr-3"><a href="#">개인정보동의</a></li>-->
<!--          <li class="mr-3"><router-link to="/plan-setting">플랜</router-link></li>-->
          <li class="mr-3"><router-link to="/">로그인</router-link></li>
        </ul>
        </div>
        </div>
      </div>
    </div>
</template>

<script>
import PlanPage from "@/views/company/PlanPage";
export default {
  name: "OuterPlanPage",
  components: {PlanPage},
  methods : {
    toLogin(){
      this.$router.push({name : 'LoginPage'})
    }
  },
  created() {
    console.log("OuterPlanPage.created");
  },
  mounted() {
    console.log("OuterPlanPage.mounted");
  },
  beforeDestroy() {
    console.log("OuterPlanPage.beforeDestroy");
  }
}
</script>
